import { render, staticRenderFns } from "./UnifiedSearchLocalSearchBar.vue?vue&type=template&id=cb3a25a4&scoped=true"
import script from "./UnifiedSearchLocalSearchBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./UnifiedSearchLocalSearchBar.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./UnifiedSearchLocalSearchBar.vue?vue&type=style&index=0&id=cb3a25a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb3a25a4",
  null
  
)

export default component.exports